import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCategories, getSubcategories, removeCategory, removeSubcategory } from 'slice/categorySlice';
import AdminTable from 'common/AdminTable';
import { useNavigate } from 'react-router-dom';

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categories, subcategories } = useSelector((state) => state.category);
  const [filterCategory, setFilterCategory] = useState('');

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getSubcategories());
  }, [dispatch]);

  const handleRemoveCategory = async (id) => {
    if (!window.confirm('Delete this category? Its sub-categories will also be deleted.')) return;
    dispatch(removeCategory(id));
  };

  const handleRemoveSubcategory = async (id) => {
    if (!window.confirm('Delete this sub-category?')) return;
    dispatch(removeSubcategory(id));
  };

  const categoryMap = useMemo(() => {
    const map = {};
    (categories || []).forEach((cat) => {
      map[cat.id] = cat.name;
    });
    return map;
  }, [categories]);

  const filteredSubcategories = useMemo(() => {
    if (!filterCategory) return subcategories || [];
    return (subcategories || []).filter(
      (sub) => String(sub.category_id) === String(filterCategory)
    );
  }, [subcategories, filterCategory]);

  const categoryHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Category Name', accessor: 'name' },
    {
      Header: 'Sub-Categories',
      id: 'subCount',
      Cell: ({ row }) =>
        (subcategories || []).filter((sub) => String(sub.category_id) === String(row.original.id)).length
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => handleRemoveCategory(row.original.id)}>
            Remove
          </button>
          <button className="btn btn-primary mx-1" onClick={() => navigate('/category/update')}>
            Edit
          </button>
        </>
      )
    }
  ];

  const subcategoryHeaders = [
    { Header: 'ID', accessor: 'id' },
    {
      Header: 'Parent Category',
      accessor: 'category_id',
      Cell: ({ value }) => categoryMap[value] || `#${value}`
    },
    { Header: 'Sub-Category Name', accessor: 'name' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => handleRemoveSubcategory(row.original.id)}>
            Remove
          </button>
          <button className="btn btn-primary mx-1" onClick={() => navigate('/category/update')}>
            Edit
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Category List</h4>
      </div>

      {categories?.length > 0 ? (
        <AdminTable tableHeaders={categoryHeaders} tableData={categories} />
      ) : (
        <p className="text-white mx-4 mt-3">No categories found.</p>
      )}

      <div className="mainheadig mx-4 mt-5">
        <h4 className="text-white font-weight-bold">Sub-Category List</h4>
      </div>

      <div className="mx-4 mt-4">
        <div className="d-flex align-items-center flex-wrap admin-filter-bar">
          <label className="adminlables mb-0 mr-2" htmlFor="subCatFilter">
            Category Filter:
          </label>
          <select
            id="subCatFilter"
            className="form-control"
            style={{ maxWidth: 340 }}
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
          <span className="ml-3 filter-count">
            {filterCategory
              ? `${categoryMap[filterCategory] || 'Selected category'} — ${filteredSubcategories.length} sub-categories`
              : `Total ${filteredSubcategories.length} sub-categories`}
          </span>
        </div>
      </div>

      {filteredSubcategories?.length > 0 ? (
        <AdminTable tableHeaders={subcategoryHeaders} tableData={filteredSubcategories} />
      ) : (
        <p className="text-white mx-4 mt-3">No sub-categories found.</p>
      )}
    </div>
  );
};

export default List;